import React from 'react'
import { NavLink } from 'react-router-dom'

// var bnr = require("./../../images/background/f-bg.jpg")

class Footer2 extends React.Component {
  render() {
    return (
      <>
        <footer className="site-footer footer-large footer-dark footer-wide">
          {/* FOOTER BLOCKES START */}
          <div
            className="footer-top overlay-wraper bg-cover"
            // style={{ backgroundImage: "url(" + bnr + ")" }}
          >
            <div className="overlay-main sx-bg-secondry-footer opacity-08" />
            <div className="container">
              <div className="row">
                {/* ABOUT COMPANY */}
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="widget widget_about">
                    {/*<h4 class="widget-title">About Company</h4>*/}
                    <div className="logo-footer clearfix p-b15">
                      <NavLink to={'./'}>
                        <img
                          className="rounded-image-circle"
                          src={require('./../../images/logo-light.png')}
                          alt="Inteshape"
                        />
                      </NavLink>
                    </div>
                    <p>
                      Askala Company for General Trading Limited stands at the
                      forefront of construction innovation as a premier provider
                      of specialized formwork solutions and slab systems.
                    </p>
                    {/* <ul className="social-icons  sx-social-links">
                      <li>
                        <a
                          href="https://www.behance.net/"
                          className="fa fa-behance"
                          target="_blank"
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://www.facebook.com"
                          className="fa fa-facebook"
                          target="_blank"
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://twitter.com"
                          className="fa fa-twitter"
                          target="_blank"
                        ></a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com"
                          className="fa fa-instagram"
                          target="_blank"
                        ></a>
                      </li>
                    </ul> */}
                  </div>
                </div>
                
                {/* USEFUL LINKS */}
                <div className="col-lg-3 col-md-6 col-sm-6 footer-col-3">
                  <div className="widget widget_services inline-links">
                    <h5 className="widget-title">Quick links</h5>
                    <ul>
                      <li>
                        <NavLink to={"/about-1"}>About</NavLink>
                      </li>
                      <li>
                        <NavLink to={"/products"}>Products</NavLink>
                      </li>
                      
                      <li>
                        <NavLink to={"/contact-us"}>Contact Us</NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
               
                {/* CONTACT US */}
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="widget widget_address_outer">
                    <h5 className="widget-title">Contact Us</h5>
                    <ul className="widget_address">
                      
                      <li>
                        Sulaimani: Arbat Main Road Sulaimani - Darfroshkan Square
                      </li>
                      
                      <li>info@askalacompany.com</li>
                      <li>+964 770 152 4633</li>
                     
                    </ul>
                  </div>
                </div>
 <div className="col-lg-3 col-md-6 col-sm-6 footer-col-3">
                  <div className="widget widget_address_outer">
                    <h5 className="widget-title">Other links</h5>
                    <ul className="social-icons  sx-social-links widget_address">
                     
                      <li>
                        <a
                          href="https://www.facebook.com/profile.php?id=61574887832523#"
                          // href="#"
                          className="fa fa-facebook"
                          target="_blank"
                        ></a>
                      </li>
                      
                      <li>
                        <a
                          // href="#"
                          href="https://www.instagram.com/askala.company/"
                          className="fa fa-instagram"
                          target="_blank"
                        ></a>
                      </li>
                    </ul>
                   
                  </div>
                </div>

              </div>
            </div>
            
          </div>
          {/* FOOTER COPYRIGHT */}
          <div className="footer-bottom overlay-wraper">
            <div className="overlay-main" />
            <div className="container">
              <div className="row">
                <div className="sx-footer-bot-left">
                  <span className="copyrights-text">
                    © 2025 All right reserved
                  </span>
                </div>

              </div>
            </div>
          </div>
        </footer>
        {/* <Switcher /> */}
      </>
    )
  }
}

export default Footer2
